<template>
    <div v-loading="!is_ok" style="position: relative">
        <div ref="main" style="height: 100%;width: 100%"></div>
        <div class="select_btn">
            <el-date-picker
                class="sale_chart_time_range"
                v-model="timeRange"
                type="daterange"
                :clearable="false"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                align="right"
                size="mini"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="date_change"
                :picker-options="pickerOptions">
            </el-date-picker>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts/core'
import moment from 'moment'
import { TooltipComponent, LegendComponent,TitleComponent,ToolboxComponent,GridComponent,DataZoomComponent} from 'echarts/components'
import request from '@/utils/request'
import { BarChart, LineChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
echarts.use(
    [ToolboxComponent, TooltipComponent,TitleComponent,GridComponent, LegendComponent, BarChart, LineChart, CanvasRenderer,DataZoomComponent]
);

export default {
    name: 'sales_charts1',
    props:[

    ],
    components:{

    },
    data(){
        return {
            timeRange:[],
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            option:{
                title:{
                    show:true,
                    text:"销量价格统计图 (日)",
                    textStyle:{
                        color:"#95aac9",
                        fontWeight:"normal"
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    },
                    formatter:function (params) {
                        return '<div>'+params[0].name + '<br>' + params[0].marker+params[0].seriesName + ':' + '<span style="color: #00B83F;">'+params[0].value + '</span>'+'</div>';
                    }
                },
                dataZoom:{
                    type:"inside"
                },
                grid:{
                    right: '13%',
                    top:"25%",
                    bottom:"10%",
                    left:"15%"
                },
                legend: {
                    top:"10%",
                    data: ['装液量', '价格'],
                    show:false
                },
                xAxis: {
                    type: 'category',
                    data: [],
                    axisLabel:{
                        show:true,
                        color:"#409EFF",
                        margin:12,
                        fontSize:12,
                    },
                },
                yAxis: [
                    {
                         name: '价格',
                        type: 'value',
                        splitNumber:4,
                        axisLabel: {
                            formatter: '{value} 吨'
                        }
                    },
                    {
                        type: 'value',
                       
                        splitNumber:4,
                        axisLabel: {
                            formatter: '{value} 元/吨'
                        }
                    },
                ],
                series: [
                    {
                        name:"价格",
                        data: [],
                        type: 'line',
                        smooth: true,
                        yAxisIndex: 1,
                        itemStyle:{
                            color:"#2ec7c9",
                            shadowBlur:3,
                            shadowColor:"#2ec7c9"
                        },
                        lineStyle:{
                            shadowBlur:3,
                            shadowColor:"#2ec7c9"
                        },
                        symbol:"emptyCircle"
                    }
                ]
            },
            is_ok:false
        }
    },
    methods:{
        getData(){
            this.is_ok = false; 
            request.post("index/sale_price_daily",{timeRange:this.timeRange}).then(res=>{
                let arr = [];
                for(let time of res.data.dates){
                    arr.push(moment(time).format("MM/DD HH:mm"));
                }
                this.option.xAxis.data = arr;
                //this.option.series[0].data = res.data.weights;
                this.option.series[0].data = res.data.prices;
                this.is_ok = true;
                this.chart = echarts.init(this.$refs["main"]);
                this.chart.setOption(this.option);
            }).catch(err=>{
                console.log(err);
                this.is_ok = true;
            });
        },
        date_change(dateRange){
            this.timeRange = dateRange;
            this.getData();
        }
    },
    created() {

    },
    mounted() {
        let range = [];
        range[0] = moment().subtract(7, 'days').format("YYYY-MM-DD").toString();
        range[1] = moment().format("YYYY-MM-DD").toString();
        this.timeRange = range;
        this.getData();
    }
}
</script>

<style scoped lang="scss">
.select_btn{
    position: absolute;
    top: 0;
    right: 0;
}
</style>
